<app-spinner name="request-remove-role"></app-spinner>
<div>
  @if (showErrorMessage) {
    <app-alert [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
  }
</div>

@if (!isRequestSuccess) {
  <div>
    <app-multi-org-filter-ta pageType="remove-role" [showRequired]="true" [showSelectRoles]="true" (onOrgChange)="onOrgChange($event)" (onRoleGroupChange)="onRoleGroupChange($event)"></app-multi-org-filter-ta>
    <div class="mtb-20 mobile-adjust">
      <div class="card fluid">
        <div class="card__content border-bottom border-gray-600">
          <div class="mb-20">
            <h3>
              Remove Role
            </h3>
          </div>
          <div>
            <b>Role Information</b>
          </div>
          <div class="mt-10"><i class="fa fa-info-circle"></i> By Removing a role, you will no longer have the permissions granted by that role and may lose access to an application altogether.</div>

          @if (userRoles?.length) {
            <div class="flex gap-30 to-block width-full mb-20 mt-30 pb-10">
              <div class="basis-50">
                <div>
                  <div>
                    <b>*Select Role(s)</b>
                  </div>
                  <ul class="role-checkbox"  style="display: flex; flex-direction: column;  overflow: auto;max-height: 500px;">
                    @for (role of userRoles; track role; let i = $index) {
                      <li class="relative"
                        >
                        <div class="lrg">
                          <input type="checkbox" [id]="'roleSelect'+i" [name]="'roleSelect'+i"
                            [value]="role.roleKey" [checked]="isSelected(role)"
                            (change)="onRoleCheckBoxChange($event, role)">
                            <label class="ml-10" for="role1">{{role.roleName}}</label>
                          </div>
                          @if (isSelected(role)) {
                            <div class="inline-text-field-container fade">
                              <div class="mb-5"><span style="color: red;font-size: 24px;">*</span>Reason for removing the Role.</div>
                              <div class="text-area-container">
                                <label for="address2"
                                class="ds-floating-label text-area">Please add reason to Remove Role</label>
                                <textarea class="textarea" name="subject" rows="3" required [(ngModel)]="role.reason"></textarea>
                              </div>
                            </div>
                          }
                        </li>
                      }
                    </ul>
                  </div>
                </div>
                <div class="basis-50">
                  <div  class="mb-30">
                    <b>Responsibilities</b>
                  </div>
                  <div class="mtb-10 responsibility" style="display: flex; flex-direction: column; overflow: auto; max-height: 500px;">
                    @for (userRole of selectedRoles; track userRole) {
                      <div class="mt-10">
                        <b>{{userRole.roleName}}</b>
                      </div>
                      @for(roleResponsibility of userRole.roleResponsibilities; track roleResponsibility) {
                          <ul class="pl-20">
                            <div>
                              <b>{{roleResponsibility.systemName}}</b>
                            </div>
                            @for(responsibility of roleResponsibility.roleResponsibility; track responsibility) {
                              <li class="pl-0">
                                {{responsibility}}
                              </li>
                            }
                          </ul>
                        }
                    }
                  </div>
                </div>
              </div>
            }
            @if (!userRoles?.length) {
              <div class="width-full">
                <div class="flex justify-center">
                  <div class="mtb-20">
                    <b>No roles found</b>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="mt-20">
        <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
          <span class="basis-50">
            <span class="flex justify-start">
              @if (selectedRoles?.length > 0) {
                <button class="rounded-4 hover-blue-800 black mobile" (click)="addRolesToCart()"
                  >
                  <div class="btn-txt font-white bold">*Add Removal(s) To Role Cart</div>
                </button>
              }
            </span>
          </span>
        </div>
      </div>
      <!-- this is the cart section -->
      <app-role-request-cart [rolesOnCart]="rolesOnCart" (removeRole)="removeRole($event)"></app-role-request-cart>
      <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
        <span class="basis-50">
          <span class="flex justify-start">
            <button [routerLink]="['..']"
              class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
              <div class="btn-txt font-red bold">Back</div>
            </button>
          </span>
        </span>
        <span class="basis-50">
          <span class="flex justify-end">
            <button class="rounded-4 hover-blue-800 black mobile"  [class.disabled]="!rolesOnCart?.length" (click)="submitRoleRequest()">
              <div class="btn-txt font-white bold">Submit Role Removal</div>
            </button>
          </span>
        </span>
      </div>
    </div>
  }

  @if (isRequestSuccess) {
    <app-role-request-success message="Your role removal request has been processed."></app-role-request-success>
  }